import { render, staticRenderFns } from "./TestimonyPage.vue?vue&type=template&id=4f940e6a&"
import script from "./TestimonyPage.vue?vue&type=script&lang=js&"
export * from "./TestimonyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports